var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Button, Input, Modal } from 'antd';
import IconFont from '../IconFont';
export default function JoinMeetingModal(props) {
    var _this = this;
    var visible = props.visible, onCancel = props.onCancel, t = props.t, onOk = props.onOk;
    var _a = React.useState(false), showPass = _a[0], setShowPass = _a[1];
    var _b = React.useState(''), meetingNum = _b[0], setMeetingNum = _b[1];
    var _c = React.useState(''), pass = _c[0], setPass = _c[1];
    var passRef = React.useRef(null);
    var onMeetingNumChange = function (event) {
        var value = event.target.value;
        if (!/^\d{0,8}$/.test(value)) {
            return;
        }
        setMeetingNum(value);
    };
    var onMeetingKeyDown = function (event) {
        var key = event.key;
        if (key !== 'Enter') {
            return;
        }
        onJoinMeeting();
    };
    var onMeetingPassChange = function (event) {
        var value = event.target.value;
        // @ts-ignore
        if (!/^\d*$/.test(value)) {
            return;
        }
        if (value && value.length > 6) {
            return;
        }
        setPass(value);
    };
    var onJoinMeeting = function () { return __awaiter(_this, void 0, void 0, function () {
        var close_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onOk) return [3 /*break*/, 2];
                    return [4 /*yield*/, onOk({
                            meetingNum: meetingNum,
                            meetingPass: pass,
                        })];
                case 1:
                    close_1 = _a.sent();
                    if (close_1) {
                        onCancel();
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var isValidMeetingNum = function () {
        return meetingNum.length === 8;
    };
    var passComp = showPass ? (React.createElement(Input, { type: "password", value: pass, ref: passRef, placeholder: t('joinMeeting.meetingPass'), onKeyDown: onMeetingKeyDown, onChange: onMeetingPassChange })) : (React.createElement("div", { className: "input-label", onClick: function () {
            setShowPass(true);
        } },
        React.createElement(IconFont, { style: { marginRight: 5 }, type: "iconapp_ic_search" }),
        t('joinMeeting.meetingPassLabel')));
    React.useEffect(function () {
        if (showPass && passRef.current) {
            passRef.current.focus();
        }
    }, [showPass]);
    return (React.createElement(Modal, { className: "me-join-meeting-modal", width: 780, visible: visible, onCancel: onCancel, bodyStyle: {
            padding: 0,
        }, footer: null },
        React.createElement("div", { className: "me-join-meeting-body" },
            React.createElement("div", { className: "me-join-meeting-form" },
                React.createElement("div", { className: "me-join-meeting-input" },
                    React.createElement(Input, { type: "text", value: meetingNum, autoFocus: true, placeholder: t('joinMeeting.meetingNum'), onKeyDown: onMeetingKeyDown, onChange: onMeetingNumChange })),
                React.createElement("div", { className: "me-join-meeting-input" }, passComp)),
            React.createElement("div", { className: "me-join-meeting-actions" },
                React.createElement(Button, { disabled: !isValidMeetingNum(), style: { opacity: isValidMeetingNum() ? 1 : 0.5 }, type: "primary", onClick: onJoinMeeting }, t('joinMeeting.join'))))));
}
//# sourceMappingURL=index.js.map